export type Operator = {
    Id: number,
    OperatorName: string,
    LabId: number | undefined,
    Department: string,
    Title: string,
    Email: string,
    InactiveDate?: Date,
}

export function apiModelToOperator(apiModel: any) {
    return {
        Id: apiModel.id,
        OperatorName: apiModel.operatorName,
        LabId: apiModel.labId,
        Department: apiModel.department,
        Title: apiModel.title,
        Email: apiModel.email,
        InactiveDate: apiModel.inactiveDate,
    } as Operator;
}

export const blankOperator = {
    Id: 0,
    OperatorName: "",
    LabId: 0,
    Department: "",
    Title: "",
    Email: "",
    InactiveDate: undefined,
} as Operator;